/**
 * O VÍNCULO da solicitação de compra — de quem é o gasto (FX-8): **projeto** (obra) ·
 * **negócio** (venda) · **cliente** · **uso interno**. Projeto e negócio amarram o cliente e
 * alimentam o realizado; os outros dois rastreiam o gasto.
 *
 * Fase 2 (16/09/2026): saiu de dentro de `SolicitacaoCompraPage` porque agora tem DOIS donos — o
 * formulário "Nova solicitação" e o **Quadro de Compras** (o gesto "Classificar" da coluna
 * "A classificar", que herdou o trabalho da antiga aba Fila). Mesma escolha, mesma validação:
 * duas telas com dois pickers divergiriam.
 *
 * ⚠️ Arquivo sem componente de propósito (react-refresh) — o `<VinculoPicker>` vive ao lado.
 */
import type {
  SolicitacaoCompra,
  TipoVinculo,
  VinculoSolicitacao,
} from '@/lib/solicitacoes-compra-store';

export interface VinculoState {
  tipoVinculo: TipoVinculo | '';
  projetoId: string;
  dealId: string;
  clienteId: string;
  setorId: string;
  categoriaId: string;
}

export const VINCULO_VAZIO: VinculoState = {
  tipoVinculo: '',
  projetoId: '',
  dealId: '',
  clienteId: '',
  setorId: '',
  categoriaId: '',
};

/** Monta o payload de vínculo (ou undefined quando incompleto/sem vínculo). */
export function buildVinculo(s: VinculoState): VinculoSolicitacao | undefined {
  switch (s.tipoVinculo) {
    case 'projeto':
      return s.projetoId ? { tipoVinculo: 'projeto', projetoId: s.projetoId } : undefined;
    case 'deal':
      return s.dealId ? { tipoVinculo: 'deal', dealId: s.dealId } : undefined;
    case 'cliente':
      return s.clienteId ? { tipoVinculo: 'cliente', clienteId: s.clienteId } : undefined;
    case 'interno':
      return { tipoVinculo: 'interno', setorId: s.setorId || null, categoriaId: s.categoriaId || null };
    default:
      return undefined;
  }
}

export function vinculoFromSolicitacao(s: SolicitacaoCompra): VinculoState {
  return {
    tipoVinculo: s.tipoVinculo ?? '',
    projetoId: s.projetoId ?? '',
    dealId: s.dealId ?? '',
    clienteId: s.clienteId ?? '',
    setorId: s.setorId ?? '',
    categoriaId: s.categoriaId ?? '',
  };
}
